const CHART_RUNTIME_FIELDS = [
  "answeredTickerIds",
  "answeredTickerMap",
  "ticker",
  "tickerDescription",
  "logoUrls",
  "tickerPrices",
  "currentPrice",
  "currentPriceUpdatedAt",
  "currentPriceUpdatedAtIso",
  "closePrice",
  "priceChange1d",
  "pricePctChange1d",
  "pricePctChangeAh",
  "pricePctChange24hr",
  "assetType",
  "label1",
  "label2",
  "label3",
  "dates",
  "values1",
  "values2",
  "values3",
  "primaryLabel",
  "availableSecondaryKeys",
  "tradingScale",
];

const hasItems = (value) => Array.isArray(value) && value.length > 0;

const hasMeaningfulValue = (value) => {
  if (value == null) return false;
  if (Array.isArray(value)) return value.length > 0;
  if (typeof value === "string") return value.trim().length > 0;
  return true;
};

const chartStateVisible = (message) => {
  const directState =
    message?.agenticChartState ||
    message?.agentic_chart_state ||
    null;
  const refinedState =
    message?.refinedQueryObj?.agentic_chart_state ||
    message?.refinedQueryObj?.agenticChartState ||
    null;
  const state = directState || refinedState;
  return state?.visible === true || state?.visible === "true";
};

const preserveStreamedChartFields = (mergedMessage, lastMessage, responseMessage) => {
  if (!hasItems(lastMessage?.answeredTickerIds)) return mergedMessage;
  if (hasItems(responseMessage?.answeredTickerIds)) return mergedMessage;
  if (!chartStateVisible(responseMessage)) return mergedMessage;

  const chartFields = {};
  CHART_RUNTIME_FIELDS.forEach((field) => {
    const value = lastMessage?.[field];
    if (hasMeaningfulValue(value)) chartFields[field] = value;
  });

  return {
    ...mergedMessage,
    ...chartFields,
  };
};

export const reconcileFinalBotMessage = (lastMessage, responseMessage) => {
  if (!responseMessage) return lastMessage;
  if (!lastMessage || lastMessage.sender !== "bot") return responseMessage;

  const preservedRuntimeFields = {};
  if (lastMessage.__stableKey) {
    preservedRuntimeFields.__stableKey = lastMessage.__stableKey;
  }
  if (lastMessage.__localKey) {
    preservedRuntimeFields.__localKey = lastMessage.__localKey;
  }

  const streamedText = typeof lastMessage.message === "string"
    ? lastMessage.message
    : "";
  const finalText = typeof responseMessage.message === "string"
    ? responseMessage.message
    : "";

  // A post-answer failure (e.g. an OpenAI timeout during follow-up/ticker
  // extraction) returns an error body even though the full answer already
  // streamed in over the WS. Keep the streamed answer and its chart rather than
  // letting the error string overwrite them; only surface the error when nothing
  // was streamed.
  if (responseMessage.isError) {
    return streamedText ? lastMessage : responseMessage;
  }

  if (streamedText === finalText) {
    return preserveStreamedChartFields({
      ...lastMessage,
      ...responseMessage,
      ...preservedRuntimeFields,
      message: streamedText,
    }, lastMessage, responseMessage);
  }

  if (streamedText && finalText.startsWith(streamedText)) {
    return preserveStreamedChartFields({
      ...lastMessage,
      ...responseMessage,
      ...preservedRuntimeFields,
      message: streamedText,
    }, lastMessage, responseMessage);
  }

  return preserveStreamedChartFields({
    ...lastMessage,
    ...responseMessage,
    ...preservedRuntimeFields,
  }, lastMessage, responseMessage);
};
